var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiBlk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.77,11.88a5.3,5.3,0,0,1,3.75,1.55l-.81.81a4.26,4.26,0,0,0-5.88,0L7,13.43A5.26,5.26,0,0,1,10.77,11.88ZM4.35,10.76l.81.81a7.94,7.94,0,0,1,11.22,0l.81-.81a9.08,9.08,0,0,0-12.84,0ZM10.8,4.41a12.66,12.66,0,0,0-9,3.73L2.61,9A11.59,11.59,0,0,1,19,9l.81-.81A12.66,12.66,0,0,0,10.8,4.41ZM9.4,15.85l1.34,1.34,1.34-1.34A1.9,1.9,0,0,0,9.4,15.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiBlk);
export default __webpack_public_path__ + "static/media/wifi_blk.ac8e2dc6ce69eebbbd4cc28640cdeb48.svg";
export { ForwardRef as ReactComponent };